export default __webpack_public_path__ + "7ed6583271437ad6bb095fb6552a3d6b.png";